(function() {
  var __blocks__ = {};
  (function() {
    var element = document.getElementById("blocks-script");
    var attribute = a = element ? element.getAttribute("data-blocks") : '';
    var blocks = a.split(",").filter(Boolean);

    for (var i = 0; i < blocks.length; i++) {
      __blocks__[blocks[i]] = true;
    }
  })();
  (function() {
  if (!__blocks__["_product-details"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('nb-product-details')) {
  customElements.define('nb-product-details', class extends HTMLElement {
    connectedCallback() {
      if (this.initialized) return;
      const variant = this.querySelector('variant-picker');
      const buy = this.querySelector('.buy-buttons-block');
      if (!buy) return;
      this.initialized = true;
      this.controller = new AbortController();
      const signal = this.controller.signal;
      const group = buy.parentElement;
      const purchase = document.createElement('div');
      purchase.className = 'nb-purchase-native';
      group.insertBefore(purchase, variant || buy);
      if (variant) purchase.append(variant);
      purchase.append(buy);
      const anchor = document.createComment('native purchase location');
      purchase.before(anchor);
      const guide = this.querySelector('.nb-size-guide-dialog');
      const dialog = this.querySelector('.nb-purchase-dialog');
      const guideButton = this.querySelector('[data-guide-trigger]').content.firstElementChild.cloneNode(true);
      purchase.prepend(guideButton);
      guideButton.addEventListener('click', () => guide.showModal(), { signal });
      const trigger = this.querySelector('[data-purchase-trigger]').content.firstElementChild.cloneNode(true);
      anchor.before(trigger);
      trigger.addEventListener('click', () => dialog.showModal(), { signal });
      for (const modal of [guide, dialog]) {
        modal.querySelector('[data-close]').addEventListener('click', () => modal.close(), { signal });
        modal.addEventListener('click', e => {
          if (e.target !== modal) return;
          const rect = modal.getBoundingClientRect();
          if (e.clientX < rect.left || e.clientX > rect.right || e.clientY < rect.top || e.clientY > rect.bottom) modal.close();
        }, { signal });
      }
      this.media = matchMedia('(max-width: 749px)');
      const update = () => {
        const mobile = this.media.matches && this.dataset.mobilePanel === 'true';
        this.classList.toggle('nb-panel-active', mobile);
        if (mobile) dialog.querySelector('[data-purchase-content]').append(purchase);
        else { dialog.close(); anchor.after(purchase); }
      };
      this.media.addEventListener('change', update, { signal });
      update();
      this.addEventListener('shopify:block:select', e => {
        if (dialog.contains(e.target) && this.classList.contains('nb-panel-active') && !dialog.open) dialog.showModal();
      }, { signal });
    }
    disconnectedCallback() { this.controller?.abort(); this.initialized = false; }
  });
}
  } catch(e) { console.error(e); }
})();

})();
